import React, { useContext } from 'react';
import { getContext } from 'common';
import { ListContext } from './List';
import { ListItemBasicContext } from './ListItemBasic';
import Styled from './styles';

export interface ListItemSubTextProps extends React.ComponentPropsWithRef<'div'> {
  /** Place content here. */
  children: React.ReactNode;
  /** Display the text as disabled. */
  disabled?: boolean;
}

/** Place second line of content here. */
const ListItemSubText = React.forwardRef<HTMLElement, ListItemSubTextProps>((props: ListItemSubTextProps, ref) => getContext(({ RTL }) => {
  const { children, disabled, ...otherProps } = props;
  const listContext = useContext(ListContext);
  const listItemBasicContext = useContext(ListItemBasicContext);
  const isDisabled = listItemBasicContext.disabled || disabled;
  return (
    <Styled.ListItemSubText ref={ref} RTL={RTL} disabled={isDisabled} $theme={listContext.theme} {...otherProps}>
      {children}
    </Styled.ListItemSubText>
  );
}));

ListItemSubText.defaultProps = {
  disabled: false,
};

ListItemSubText.displayName = 'ListItemSubText';

/* Exports */
export { ListItemSubText as default };
